import(/* webpackMode: "eager" */ "/app/typescript/apps/worker-web/src/app/[locale]/not-found.tsx");
